export enum AccountOrderDetailPageState {
  Paying = 'paying',
  ChangingShippingAddress = 'change-shipping-method'
}
